import * as React from "react";
import { Copy, Check } from "lucide-react";

interface NdcLinkProps {
  ndc: string;
  onClick?: (ndc: string) => void;
  className?: string;
}

export function NdcLink({ ndc, onClick, className = "" }: NdcLinkProps) {
  const [copied, setCopied] = React.useState(false);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    onClick?.(ndc);
  };

  const handleCopy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    await navigator.clipboard.writeText(ndc);
    setCopied(true);
    setTimeout(() => setCopied(false), 1500);
  };

  return (
    <span className={`group inline-flex items-center gap-1.5 ${className}`}>
      <button
        onClick={handleClick}
        className="whitespace-nowrap font-mono text-sm font-semibold text-primary underline-offset-4 hover:underline transition-colors cursor-pointer"
      >
        {ndc}
      </button>
      <button
        onClick={handleCopy}
        className="opacity-0 group-hover:opacity-100 transition-opacity text-muted-foreground hover:text-primary focus:opacity-100"
        aria-label="Copy NDC"
      >
        {copied ? (
          <Check className="h-3.5 w-3.5 text-green-500" />
        ) : (
          <Copy className="h-3.5 w-3.5" />
        )}
      </button>
    </span>
  );
}
